import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

import { Timeframe } from "../types/timeframe";

type TimeframeSelectorProps = {
  value: string;
  onChange: (value: string) => void;
};

export function TimeframeSelector({ value, onChange }: TimeframeSelectorProps) {
  const options: { label: string; value: Timeframe }[] = [
    { label: "W", value: "w" },
    { label: "M", value: "m" },
    { label: "6M", value: "6m" },
  ];

  return (
    <Tabs value={value} onValueChange={onChange} className="mr-2">
      <TabsList className="rounded-lg border border-[#E4E7EC] bg-[#F2F4F7] p-1 dark:border-input dark:bg-card">
        {options.map((option) => (
          <TabsTrigger
            value={option.value}
            className="flex-1"
            key={option.value}
          >
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
